import { render, staticRenderFns } from "./UserVisitsSectorPage.vue?vue&type=template&id=670d6a45&"
import script from "./UserVisitsSectorPage.vue?vue&type=script&lang=js&"
export * from "./UserVisitsSectorPage.vue?vue&type=script&lang=js&"
import style0 from "./UserVisitsSectorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports